import * as React from 'react';
const SvgErrorTriangleFill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.06 3.125c.863-1.5 3.017-1.5 3.88 0l7.757 13.5c.862 1.5-.216 3.375-1.94 3.375H4.243c-1.724 0-2.802-1.875-1.94-3.375zM12 7c-.667 0-1.195.573-1.147 1.247l.353 5.005A.8.8 0 0 0 12 14a.8.8 0 0 0 .794-.748l.353-5.005A1.16 1.16 0 0 0 12 7m0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgErrorTriangleFill;
